import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const instructorApi = createApi({
  reducerPath: "instructorApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/api/instructor" }),
  tagTypes: ["Instructor"],
  endpoints: (builder) => ({
    getinstructors: builder.query({
      query: () => "/",
      providesTags: ["Instructor"],
    }),

    addInstructor: builder.mutation({
      query: (newInstructor) => ({
        url: "/register",
        method: "POST",
        body: newInstructor,
      }),
      invalidatesTags: ["Instructor"],
    }),
    updateInstructor: builder.mutation({
      query: ({ id, ...updatedInstructor }) => ({
        url: `/${id}`,
        method: "PUT",
        body: updatedInstructor,
      }),
      invalidatesTags: ["Instructor"],
    }),
    deleteInstructor: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Instructor"],
    }),
  }),
});

export const {
  useGetinstructorsQuery,
  useAddInstructorMutation,
  useUpdateInstructorMutation,
  useDeleteInstructorMutation,
} = instructorApi;
